import type { OpenedPhotos } from './RejectedScanPhotoViewer';

export interface RejectedScansNav {
    scanId: number | null;
    photos: OpenedPhotos | null;
}

export const LIST_NAV: RejectedScansNav = { scanId: null, photos: null };

// One level up: the photo viewer, then the scan view; null means the list is showing, so close.
export function stepBack(nav: RejectedScansNav): RejectedScansNav | null {
    if (nav.photos) return { ...nav, photos: null };
    return nav.scanId == null ? null : LIST_NAV;
}

export function adjacentScanId(
    scans: readonly { scanId: number }[],
    scanId: number,
    offset: -1 | 1
): number | null {
    const index = scans.findIndex((scan) => scan.scanId === scanId);
    return index < 0 ? null : (scans[index + offset]?.scanId ?? null);
}
